import { render, staticRenderFns } from "./MoneyDisplay.vue?vue&type=template&id=27d51fc4&"
import script from "./MoneyDisplay.vue?vue&type=script&setup=true&lang=ts&"
export * from "./MoneyDisplay.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports